import React from 'react';
import { ChatHelper } from '../helpers';
import { ChatMessage, LiveChatData, ScreenType } from '../types';
import { formatMessageTime } from '../utils/date';

type TimeTextProps = {
  screenType?: ScreenType | null;
  chatHelper?: ChatHelper | null;
  message?: ChatMessage | null;
  chatData?: LiveChatData | null;
};

const TimeText: React.FC<TimeTextProps> = ({ screenType = null, chatHelper = null, message = null, chatData = null }) => {
  const getServerNow = () =>
    chatData?.serverTimeOffset != null ? new Date(Date.now() + chatData.serverTimeOffset!) : new Date();
  let timestamp = getServerNow();
  if (screenType && chatHelper && message) {
    // TODO: Make it optional from the config
    // if (!chatHelper.showTimeBar(message)) {
    //   return null;
    // }
    timestamp = message.created;
  }
  return (
    <div className="chatyme-message-item chatyme-time-border">
      <div className="chatyme-time-text">
        {(() => {
          if (!timestamp) {
            return '';
          }
          try {
            const date =
              timestamp instanceof Date
                ? timestamp
                : typeof timestamp === 'number'
                  ? new Date(timestamp)
                  : new Date(timestamp);
            return formatMessageTime(date, getServerNow());
          } catch (e) {
            console.error('Error formatting message time:', e);
            return '';
          }
        })()}
      </div>
    </div>
  );
};

export default TimeText;

